import React from 'react';
import { Card, CardContent, CardHeader, Divider } from '@material-ui/core';
import { DatePicker } from '@material-ui/pickers';
import { useFormikContext } from 'formik';
import { ISettingsGroups } from '../interfaces';
import moment from 'moment';

interface IProps {
  disabled?: boolean;
}

const DefectActSettings = ({ disabled }: IProps) => {
  const { values, setFieldValue } = useFormikContext<{ settings: ISettingsGroups }>();

  const {
    groupName,
    settings: [DEFECT_ACT_RATING_START_DATE],
  } = values.settings[3];

  const field = (index: number) => `settings[3].settings[${index}].value`;

  return (
    <Card>
      <CardHeader title={groupName} />
      <Divider />

      <CardContent>
        <DatePicker
          inputVariant="filled"
          format="dd.MM.yyyy"
          label={DEFECT_ACT_RATING_START_DATE.description}
          value={moment(DEFECT_ACT_RATING_START_DATE.value)}
          disabled={disabled}
          onChange={(date) => setFieldValue(field(0), date)}
          fullWidth
        />
      </CardContent>
    </Card>
  );
};

export default DefectActSettings;
